import React, {createContext, Dispatch, FunctionComponent, SetStateAction, useContext, useState} from "react";
import {EngageAppContext} from "../App";

export enum ChatUIState {
    none,
    focused
}

export type SelectionRange = {
    start:number
    end:number
}

type ContextProps = {
    setChatReadCount: Dispatch<SetStateAction<number>>
    chatReadCount:number
    chatUIState: ChatUIState
    setChatUIState: Dispatch<SetStateAction<ChatUIState>>
    messageInput: string
    setMessageInput: Dispatch<SetStateAction<string>>
    selectionRange: SelectionRange
    setSelectionRange: Dispatch<SetStateAction<SelectionRange>>
}

export const ChatContext = createContext<ContextProps>({} as ContextProps);

let ChatContextProvider: FunctionComponent = ({children}) => {
    const {userState} = useContext(EngageAppContext.current);
    const [chatReadCount, setChatReadCount] = useState(userState.chatReadCount);
    const [chatUIState, setChatUIState] = useState<ChatUIState>(ChatUIState.none);
    const [messageInput, setMessageInput] = useState("");
    const [selectionRange, setSelectionRange] = useState<SelectionRange>({start:0,end:0});

    return <ChatContext.Provider value={{
        chatReadCount,
        setChatReadCount,
        chatUIState,
        setChatUIState,
        messageInput,
        setMessageInput,
        selectionRange,
        setSelectionRange
        }}>
        {children}
    </ChatContext.Provider>;
};

export default ChatContextProvider;